var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b({ class: _vm.computedClass }, "div", _vm.$attrs, false),
    [
      _c("div", { staticClass: "jade-page-header__main-navigation" }, [
        _c(
          "div",
          [
            _vm.hasOnNavigate && !_vm.hideNavigation
              ? _c("jade-icon-button", {
                  attrs: {
                    variant: "neutral-ghost",
                    "aria-label":
                      _vm.navigateType === "back" ? "Voltar" : "Fechar",
                    icon: _vm.navigateType === "back" ? "arrow-left" : "close",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onNavigate")
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "jade-page-header__title" },
          [
            _c("jade-text", { attrs: { variant: "heading-xsmall" } }, [
              _vm._v(_vm._s(_vm.label)),
            ]),
          ],
          1
        ),
        _vm.hasTrailingAction || _vm.$slots.trailingItem
          ? _c("div", { staticClass: "jade-page-header__trailing" }, [
              _vm.hasTrailingAction
                ? _c(
                    "div",
                    { staticClass: "jade-page-header__trailing-action-medium" },
                    [
                      _c("jade-icon-button", {
                        attrs: {
                          size: "medium",
                          variant: "neutral-subtle",
                          icon: _vm.trailingAction?.icon,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("trailingActionClick")
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasTrailingAction
                ? _c(
                    "div",
                    { staticClass: "jade-page-header__trailing-action-large" },
                    [
                      _c(
                        "jade-button",
                        {
                          attrs: {
                            size: "medium",
                            variant: "neutral-subtle",
                            icon: _vm.trailingAction?.icon,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("trailingActionClick")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.trailingAction.text) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", [_vm._t("trailingItem")], 2),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }